<template>
    <div class="qbordercolour" style="padding-left: auto">
        <template v-if="slidesloaded">
            <div class="grid-x">
            <div class="cell medium-12 large-12">
            <!-- <carousel ref="carousel" :paginationEnabled="false" :perPage="1" :navigationEnabled="false" :autoplay="true" :autoplayHoverPause="true" :loop="true" :autoplayTimeout="7000" :speed="100"> -->
            <SsrCarousel v-model="page" ref="carousel" :slides-per-page="1" :loop="true" :autoplay-delay="6" :show-dots="$mq === 'md'">

                <!-- are there any slides at all -->
                <div class="slide" v-if="slidesdata.length==0">
                    <h5 class="cell text-center">Welcome to Oddsgalore</h5>
                    <div class="cell">We compare and analyse bookmaker and exchange odds</div>
                    <div class="cell">You can personalise what odds you see and how you see them</div>
                    <div class="cell">We bring you all the latest hints, odds spots and gossip</div>
                    <div class="cell">And the best new and existing customer bookmakerpromotions</div>
                </div>

                <div
                    class="slide"
                    v-else
                    style="font-weight: bold"
                    v-for="(row0,i0) in slidesdata"
                    :KEY="i0"
                >

                    <template v-if="row0.slide[0].slidertype=='O'">
                        <!-- <slide :key="i0"> -->
                        <div :key="i0">
                            <div
                                class="container hero-bg"
                                :style="{'backgroundImage': 'url(' + require('/public/assets/images/carousel/' + row0.slide[0].imagelocation) + ')'}">

                                <div class="square">
                                    <div class="slideheader">
                                        <img
                                            class="qwhiteicon"
                                            style="margin-right: 10px;height:28px;width:28px;margin-bottom:2px"
                                            src="/assets/icons/horses-mouth.png"
                                        />
                                        Big Events: {{$todayTomorrow(row0.slide[0].event[0].startdate, $dateformattype.daylong)}}
                                        {{$displayDate(row0.slide[0].event[0].startdate,$dateformattype.daymonth)}}
                                    </div>
                                    <!-- <div style="margin-left:auto; margin-right: auto; margin-top:60px; min-width:30%;max-width: 80%;">
                                        <singleadverts :row="row0.slide[0].event[0]" :backcolour="row0.slide[0].event[0].PromoBackColour"></singleadverts>
                                    </div> -->
                                      <div
                                            style="padding-top:70px;padding-left:30px;margin-right:-50px;color:white;z-index:99999; line-height:1.5em; font-size:1.2em;text-align: left"
                                        >
                                            {{ row0.slide[0].majortext }}

                                        </div>
                                        <div style="padding-left:30px;margin-right:20px;padding-top:5%;color:white;z-index:99999; line-height:2em; font-size:1.2em;text-align: left">
                                                <actionbutton fontsize="12px" :routerlinkpath="row0.slide[0].buttonurl" :buttontext="row0.slide[0].buttontext" ></actionbutton>
                                            </div>
                                        <!-- <div
                                            style="padding-left:20px;padding-top:15%;margin-right:-50px;color:white;z-index:99999; line-height:1.5em; font-size:0.6em; text-align: left"
                                        >
                                            {{ row0.slide[0].minortext }}
                                        </div> -->
                                </div>

                                <div class="triangle"></div>

                                <!-- main right side content -->
                                <div style="height:230px; flex: 1 1 auto;">
                                    <div style="font-weight: bold;color:white"></div>
                                    <div style="padding: 15px 20px 0px 20px"></div>

                                    <div  v-for="(row,i) in row0.slide[0].event" :key=i>
                                        <div>
                                            <router-link :to="$URLCreateTS('Competition',row.sport,row.venue,row.competition,row.eventdesc,row.t,row.tpoid,row.compid)">
                                                <div class="cell">
                                                    <div class="grid-x qsupersmallfont " style="margin-top:10px;color:black">
                                                        <div class="cell small-9 top-tab" style="margin-left:26px;">
                                                            <div style="margin-right:4px;display: inline-block;">
                                                                <span
                                                                    style="padding-right: 20px;"
                                                                    :class="row.sport + 'Small'"
                                                                    onerror="this.onerror=null;this.src='/assets/images/flags/svg/International.svg'"
                                                                    class="qwhiteicon"
                                                                ></span>
                                                                {{ $displayDate(row.startdate,$dateformattype.timeonly)  }} - {{ row.competition}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </div>

                                        <div class="pill-row-wrapper-odds" style="padding-right:20px">
                                            <router-link
                                                :to="$URLCreateTS(row.urlstub,row.sport,row.venue,row.competition,row.eventdesc,row.t,row.tpoid)"
                                                custom
                                                v-slot="{ href, navigate }"
                                            >
                                                <a :href="href" @click="clickGoEvents(navigate,row.t,row.tpoid)">
                                                    <div class="pillwrap">
                                                        <div class="grid-x slider-row no-gutters" >
                                                            <div
                                                                class="cell small-1 slidertextleft"
                                                                v-if="row.venue!=undefined"
                                                            >
                                                                <img
                                                                    style="margin-left: 3px; margin-bottom:3px"
                                                                    class="qflagsmall"
                                                                    :src="'/assets/images/flags/svg/' + row.venue + '.svg'"
                                                                    alt=""
                                                                    onerror="this.onerror=null;this.src='/assets/images/flags/svg/International.svg'"
                                                                />
                                                            </div>
                                                            <div class="cell small-10 slidertextsimple">
                                                                {{ row.eventdesc  }}
                                                            </div>
                                                            <div class="cell small-1  slidertextright">
                                                                <span class="arrow">
                                                                    &#x279C;
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- </slide> -->
                    </template>

                    <template v-if="row0.slide[0].slidertype=='I'">
                        <div style="color:black" v-html="getStaticSlide(row0.slide[0].filedatalocation)"></div>
                    </template>

                    <template v-if="row0.slide[0].slidertype=='P'">
                        <div style="color:black;">
                            <!-- <slide :key="i0" style="color:black;"> -->
                            <div
                                class="container hero-bg"
                                :style="{'backgroundImage': 'url(' + require('/public/assets/images/carousel/' + row0.slide[0].imagelocation) + ')'}"

                            >
                                <div class="grid-x" style="padding-top:50px">
                                    <div class="cell auto">
                                        <div style="padding-left:140px">
                                            <div class="cell small-12">
                                                <div class="grid-x" style="padding-right:15px; margin-left:-20px">
                                                    <template v-for="(row,i) in row0.slide[0].promos">
                                                        <div
                                                            class="cell small-4"
                                                            style="font-size:x-small; color:black; font-weight: bold; padding-right:10px;"
                                                            :key=i
                                                        >
                                                            <singleadverts :row="row" :backcolour="row.BackColour"></singleadverts>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div style="position:fixed;top:170px;padding-left:30px;width: 77px;">
                                    <div style="border-radius: 47px; background-color: snow; height: 45px;">
                                        <img style="padding:5px" src="/assets/icons/megafone.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- </slide> -->
                    </template>

                    <template v-if="row0.slide[0].slidertype=='W'" style="color:black">

                        <!-- <slide :key="i0" style="color:black;"> -->
                        <div style="color:black;">
                            <div
                                class="container hero-bg"
                                :style="{'backgroundImage': 'url(' + require('/public/assets/images/carousel/' + row0.slide[0].imagelocation) + ')'}"

                            >
                                <div class="square">

                                    <router-link
                                        :to="$URLCreateTS('Outright',row0.slide[0].winner[0].Sport,'',row0.slide[0].winner[0].CompDesc,row0.slide[0].winner[0].ORBetType,'','')"
                                        custom
                                        v-slot="{ href, navigate }"
                                    >
                                        <a
                                            :href="href"
                                            @click="clickGoComps(navigate,row0.slide[0].winner[0].CompDesc, row0.slide[0].winner[0].CompID)"
                                        >
                                            <div class="slideheader">
                                                <img
                                                    class="qwhiteicon"
                                                    style="width:24px;height:24px;margin-bottom:3px;margin-right: 8px;"
                                                    :src="'/assets/images/sports/svg/' + row0.slide[0].winner[0].Sport + '.svg'"
                                                />
                                               {{row0.slide[0].winner[0].CompDesc}}
                                                <!-- {{row0.slide[0].winner[0].CompDesc}} - {{row0.slide[0].winner[0].ORBetType}} -->
                                            </div>
                                        </a>
                                    </router-link>
                                    <div style="padding-top:70px;padding-left:30px;margin-right:-30px;color:white;z-index:99999; line-height:1.5em; font-size:1.2em;text-align: left">
                                        <!-- <singleadverts :row="row0.slide[0].winner[0]" :backcolour="row0.slide[0].winner[0].PromoBackColour"></singleadverts> -->
                                        {{ row0.slide[0].majortext }}
                                    </div>
                                     <div STYLE="padding-left:30px;margin-right:20px;padding-top:5%;color:white;z-index:99999; line-height:2em; font-size:1.1em;text-align: left">
                                                <actionbutton fontsize="12px" :routerlinkpath="row0.slide[0].buttonurl" :buttontext="row0.slide[0].buttontext" ></actionbutton>
                                            </div>
                                            <div style="padding-left:30px;padding-top:5%;margin-right:-50px;color:white;z-index:99999; line-height:1.5em; font-size:0.6em; text-align: left">
                                                {{ row0.slide[0].minortext }}
                                            </div>
                                </div>

                                <div class="triangle"></div>

                                <div style="height:230px; flex: 1 1 auto;">
                                    <div style="font-weight: bold;color:white"></div>
                                    <div style="padding: 10px 20px 0px 20px">
                                        <div class="pill-row-wrapper" v-for="(row,i) in row0.slide[0].winner[0].event.slice(0,5)" :key="i">
                                            <router-link
    :to="$URLCreateTS(
      'Outright',
      row0.slide[0].winner[0].Sport,
      '',
      row0.slide[0].winner[0].CompDesc,
      row0.slide[0].winner[0].CompDesc,
      row0.slide[0].winner[0].ORBetType,
      '',
      ''
    )"
    custom
    v-slot="{ href, navigate }"
  >
    <a
      :href="href"
      @click="clickGoComps(
        navigate,
        (row0.slide[0].winner[0].CompDesc).substring(
          0,
          row0.slide[0].winner[0].CompDesc.indexOf('  -')
        ),
        row0.slide[0].winner[0].CompID
      )"
    >
      <!-- pill wrapper -->
      <div class="pillwrap" style="margin-top:4px">
        <div class="grid-x slider-row ">
          <div class="cell small-2 slidertextleft">
            <kit
              sport="Soccer"
              :vmagnify="10"
              :hmagnify="10"
              :teamname="row.Competitor"
            />
          </div>

          <div class="cell small-7 slidertextsimple">
            {{ row.Competitor }}
          </div>

          <div class="cell small-2 slidertextodds">
            {{ $formatOddsTS(row.Odds) }}
          </div>
        </div>

      </div>

    </a>

                                            </router-link>

                                        </div>

                                        <router-link :to="$URLCreateTS('Outright',row0.slide[0].winner[0].Sport,'',row0.slide[0].winner[0].CompDesc,row0.slide[0].winner[0].CompDesc,row0.slide[0].winner[0].ORBetType,'','')" custom v-slot="{ href, navigate }">
                                          <a :href="href" @click="clickGoComps(navigate,(row0.slide[0].winner[0].CompDesc).substring(0,row0.slide[0].winner[0].CompDesc.indexOf('  -')),row0.slide[0].winner[0].CompID)"
                                        ><div style="text-align: right;color: white; font-size: 12px;margin-top:6px"> See all the Odds <span class="arrow">
                                                                    &#x279C;
                                                                </span></div></a></router-link>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- </slide> -->
                    </template>

                    <template v-if="row0.slide[0].slidertype.startsWith('B') && row0.slide[0].Best != undefined" style="color:black">
                        <div style="color:#0d0b38">

                            <!-- <slide style="color:#0d0b38" :key="i0"> -->
                            <a
                                :href="'/bookmakerloader.html?bkm=' + row0.slide[0].Best[0].Description + '&country=' + $store.state.countryname"
                                target="_blank"
                            >
                                <div
                                    class="container hero-bg"
                                    :style="{'backgroundImage': 'url(' + require('/public/assets/images/carousel/' + row0.slide[0].imagelocation) + ')'}"

                                >
                                    <div class="square">
                                        <div class="slideheader">
                                            <img
                                                class="qwhiteicon"
                                                style="margin-right: 5px;height:28px;width:28px;margin-bottom:2px"
                                                src="/assets/icons/megafone.png"
                                            />
                                            {{row0.slide[0].tabname}} in {{ previousMonth() }}
                                        </div>
                                        <div
                                            style="padding-top:70px;padding-left:20px;margin-right:-50px;color:white;z-index:99999; line-height:1.5em; font-size:1.2em;text-align: left"
                                        >
                                            {{ row0.slide[0].Best[0].MajorText }}
                                            <span
                                                style="display: inline-block;margin-left:10px"
                                                class="qsmallcircularpop tick"
                                                :title="langConv('Oddsgalore Best in Class')"
                                            ></span>
                                        </div>
                                        <div style="padding-left:20px;margin-right:20px;padding-top:5%;color:white;z-index:99999; line-height:2em; font-size:1.2em;text-align: left">
                                                <actionbutton fontsize="12px" :routerlinkpath="row0.slide[0].buttonurl" :buttontext="row0.slide[0].buttontext" ></actionbutton>
                                            </div>
                                        <div
                                            style="padding-left:20px;padding-top:5%;margin-right:-50px;color:white;z-index:99999; line-height:1.5em; font-size:0.6em; text-align: left"
                                        >
                                            {{ row0.slide[0].Best[0].MinorText }}
                                        </div>
                                    </div>

                                    <div class="triangle"></div>

                                    <div style="margin-left:auto; margin-right: auto; margin-top:50px; min-width:30%;max-width: 80%">
                                        <singleadverts :row="row0.slide[0].Best[0]" :backcolour="row0.slide[0].Best[0].BackColour"></singleadverts>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <!-- </slide> -->
                    </template>

                    <!-- petes predictions-->
                   <template v-if="row0.slide[0].slidertype=='PP'" style="color:black">
                        <div>
                            <div class="container hero-bg" :style="{'backgroundImage': 'url(' + require('/public/assets/images/carousel/' + row0.slide[0].imagelocation) + ')'}">

                                <div class="square">

                                            <div class="slideheader">
                                                <img
                                                    
                                                    style="width:24px;height:24px;margin-bottom:3px;margin-right: 8px;"
                                                    src="/assets/icons/pete.png"
                                                />
                                               {{ row0.slide[0].tabname}} W/C {{ row0.slide[0].data[0].startdateofweek }}
                                             </div>

                                            <div style="padding-top:70px;padding-left:30px;margin-right:-50px;color:white;z-index:99999; line-height:1.5em; font-size:1.2em;text-align: left">
                                                4 bets we backed this week
                                            </div>
                                            <div  style="padding-left:30px;margin-right:-50px;color:white;z-index:99999; line-height:1.5em; font-size:1.2em;text-align: left">
                                                Return YTD = <span  >{{  row0.slide[0].ytdroi }}</span> %
                                            </div>
                                            <div STYLE="padding-left:30px;margin-right:20px;padding-top:5%;color:white;z-index:99999; line-height:2em; font-size:1.2em;text-align: left">
                                                <actionbutton fontsize="12px" :routerlinkpath="row0.slide[0].buttonurl" :buttontext="row0.slide[0].buttontext" ></actionbutton>
                                            </div>
                                            <div style="padding-left:30px;padding-top:5%;margin-right:-50px;color:white;z-index:99999; line-height:1.5em; font-size:0.6em; text-align: left">
                                                {{row0.slide[0].minortext}}
                                            </div>

                                        <!-- </a>
                                    </router-link> -->
                                    <!-- <div style="margin-left:auto; margin-right: auto; margin-top:60px; min-width:30%;max-width: 80%">
                                        <singleadverts :row="row0.slide[0].winner[0]" :backcolour="row0.slide[0].winner[0].PromoBackColour"></singleadverts>
                                    </div> -->

                               </div>
                               <div class="triangle"></div>
                               <div style="height:238px; flex: 1 1 auto;">
                                    <div style="font-weight: bold;color:white"></div>
                                    <div style="padding: 0px 0px 10px 10px"></div>

                                    <div  v-for="(row,i) in row0.slide[0].data" :key=i>

                                        <div class="" style="padding-right:20px;margin-bottom: 4px;">

                                            <router-link
                                                :to="$URLCreateTS(row.urlstub,row.sport,row.venue,row.competition,row.eventdesc,row.t,row.tpoid)"
                                                custom
                                                v-slot="{ href, navigate }"
                                            >
                                                <a :href="href" @click="clickGoEvents(navigate,row.t,row.tpoid)">
                                                    <div class="slidertextsmall" style="border-radius: 8px;">
                                                          <div
                                                                class="grid-x slidertextsmall"
                                                                v-if="row.venue!=undefined" style="background-color: #274C77; border-radius:5px 5px 0px 0px"
                                                            >

                                                            <div class="cell auto auto-truncate" style="margin-left:3px;text-align: left; ">
                                                            <div  style="display: inline-block;">
                                                                <span

                                                                    :class="row.sport + 'Small'" class="qwhiteicon" style="margin-bottom:2px"
                                                                    onerror="this.onerror=null;this.src='/assets/images/flags/svg/International.svg'"
                                                                   :alt="row.sport"
                                                                ></span>

                                                            </div>

                                                                <img
                                                                    style="margin-left: 3px; margin-bottom:2px;margin-right:3px"
                                                                    class="qflagextrasmall"
                                                                    :src="'/assets/images/flags/svg/' + row.venue + '.svg'"
                                                                    alt=""
                                                                    onerror="this.onerror=null;this.src='/assets/images/flags/svg/International.svg'"
                                                                />
                                                             {{ row.eventdesc}}</div>
                                                             <div class="cell shrink" style="font-size:8px;color:white;font-weight: bold;" >
                                                                &nbsp;&nbsp;{{ $displayDate(row.StartofEvent,$dateformattype.daymonthshort)}}&nbsp;&nbsp;{{ row.startdate }}
                                                            </div>
                                                             </div>

                                                        <div class="grid-x" style="line-height: 1 !important;margin-top:4px">
                                                          <div :class="['status-icon', row.outcome]" class="cell small-1"></div>
                                                            <div class="cell small-10 slidertextsimple text-center" style="margin-bottom: 1px;">
                                                                {{ row.backedteam  }} @ {{ row.odds }}
                                                            </div>
                                                            <div class="cell small-1" style="text-align: right;padding-right:5px; margin-bottom: 1px;" v-if="row.outcome=='awaiting'">
                                                                <span class="arrow" >
                                                                    &#x279C;
                                                                </span>
                                                            </div>
                                                            </div>
                                                        </div>

                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </template>

                    <!-- AI predictions -->
                    <template v-if="row0.slide[0].slidertype=='AI'" style="color:black">
                        <div>
                            <div class="container hero-bg" :style="{'backgroundImage': 'url(' + require('/public/assets/images/carousel/' + row0.slide[0].imagelocation) + ')'}">

                                <div class="square">

                                            <div class="slideheader">
                                                <img
                                                    
                                                    style="width:24px;height:24px;margin-bottom:3px;margin-right: 8px;"
                                                    src="/assets/icons/AI.png"
                                                />
                                               {{ row0.slide[0].tabname}} W/C {{ row0.slide[0].data[0].startdateofweek }}
                                             </div>

                                            <div style="padding-top:70px;padding-left:30px;margin-right:-50px;color:white;z-index:99999; line-height:1.5em; font-size:1.2em;text-align: left">
                                                4 bets we backed this week
                                            </div>
                                            <div  style="padding-left:30px;margin-right:-50px;color:white;z-index:99999; line-height:1.5em; font-size:1.2em;text-align: left">
                                                Return YTD = <span  >{{  row0.slide[0].ytdroi }}</span> %
                                            </div>
                                            <div STYLE="padding-left:30px;margin-right:20px;padding-top:5%;color:white;z-index:99999; line-height:2em; font-size:1.2em;text-align: left">
                                                <actionbutton fontsize="12px" :routerlinkpath="row0.slide[0].buttonurl" :buttontext="row0.slide[0].buttontext" ></actionbutton>
                                            </div>
                                            <div style="padding-left:30px;padding-top:5%;margin-right:-50px;color:white;z-index:99999; line-height:1.5em; font-size:0.6em; text-align: left">
                                                {{row0.slide[0].minortext}}
                                            </div>

                                        <!-- </a>
                                    </router-link> -->
                                    <!-- <div style="margin-left:auto; margin-right: auto; margin-top:60px; min-width:30%;max-width: 80%">
                                        <singleadverts :row="row0.slide[0].winner[0]" :backcolour="row0.slide[0].winner[0].PromoBackColour"></singleadverts>
                                    </div> -->

                               </div>
                               <div class="triangle"></div>
                               <div style="height:238px; flex: 1 1 auto;">
                                    <div style="font-weight: bold;color:white"></div>
                                    <div style="padding: 0px 0px 10px 10px"></div>

                                    <div  v-for="(row,i) in row0.slide[0].data" :key=i>

                                        <div class="" style="padding-right:20px;margin-bottom: 4px;">

                                            <router-link
                                                :to="$URLCreateTS(row.urlstub,row.sport,row.venue,row.competition,row.eventdesc,row.t,row.tpoid)"
                                                custom
                                                v-slot="{ href, navigate }"
                                            >
                                                <a :href="href" @click="clickGoEvents(navigate,row.t,row.tpoid)">
                                                    <div class="slidertextsmall" style="border-radius: 8px;">
                                                          <div
                                                                class="grid-x slidertextsmall"
                                                                v-if="row.venue!=undefined" style="background-color: #274C77; border-radius:5px 5px 0px 0px"
                                                            >

                                                            <div class="cell auto auto-truncate" style="margin-left:3px;text-align: left; ">
                                                            <div  style="display: inline-block;">
                                                                <span

                                                                    :class="row.sport + 'Small'" class="qwhiteicon" style="margin-bottom:2px"
                                                                    onerror="this.onerror=null;this.src='/assets/images/flags/svg/International.svg'"
                                                                   :alt="row.sport"
                                                                ></span>

                                                            </div>

                                                                <img
                                                                    style="margin-left: 3px; margin-bottom:2px;margin-right:3px"
                                                                    class="qflagextrasmall"
                                                                    :src="'/assets/images/flags/svg/' + row.venue + '.svg'"
                                                                    alt=""
                                                                    onerror="this.onerror=null;this.src='/assets/images/flags/svg/International.svg'"
                                                                />
                                                             {{ row.eventdesc}}</div>
                                                             <div class="cell shrink" style="font-size:8px;color:white;font-weight: bold;" >
                                                                &nbsp;&nbsp;{{ $displayDate(row.StartofEvent,$dateformattype.daymonthshort)}}&nbsp;&nbsp;{{ row.startdate }}
                                                            </div>
                                                             </div>

                                                        <div class="grid-x" style="line-height: 1 !important;margin-top:4px">
                                                          <div :class="['status-icon', row.outcome]" class="cell small-1"></div>
                                                            <div class="cell small-10 slidertextsimple text-center" style="margin-bottom: 1px;">
                                                                {{ row.backedteam  }} @ {{ row.odds }}
                                                            </div>
                                                            <div class="cell small-1" style="text-align: right;padding-right:5px; margin-bottom: 1px;" v-if="row.outcome=='awaiting'">
                                                                <span class="arrow" >
                                                                    &#x279C;
                                                                </span>
                                                            </div>
                                                            </div>
                                                        </div>

                                                </a>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </template> 

                </div>


            </SsrCarousel>
            </div>
         
            <div class="cell xlarge-12 medium-0 qbordercolour" style="height:35px; overflow-x: auto" v-if="slidesloaded && slidesdata.length>0&&$mq == 'lg'">
            <template>
                <div class="grid-x">
                    <template v-for="(rowa,ia) in slidesdata">

                        <template  v-if="rowa.slide[0].slidertype=='O'">
                            <div  class="cell small-3"  :key="ia">
                                <div
                                    class="basicslider"
                                    v-bind:class="[{ currentslider: currentSlide(Math.floor(ia)), noncurrentslider: !currentSlide(Math.floor(ia))}]"
                                    v-on:click="goToSlide(Math.floor(ia));"
                                >
                                    <div>
                                        {{$displayDate(rowa.slide[0].event[0].startdate, $dateformattype.day)}}
                                        <!-- <span style="font-size: x-small;"> -->
                                            {{$displayDate(rowa.slide[0].event[0].startdate,$dateformattype.daymonth)}}
                                        <!-- </span> -->
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template  v-if="rowa.slide[0].slidertype=='I'">
                            <div  class="cell small-3" :key="ia">
                                <div
                                    class="basicslider"
                                    v-bind:class="[{ currentslider: currentSlide(Math.floor(ia)), noncurrentslider: !currentSlide(Math.floor(ia))}]"
                                    v-on:click="goToSlide(Math.floor(ia));"
                                >
                                    <div v-html="langConv(rowa.slide[0].tabname)"></div>
                                </div>
                            </div>
                        </template>

                        <template  v-if="rowa.slide[0].slidertype=='P'">
                            <div class="cell small-3" :key="ia">
                                <div
                                    class="basicslider"
                                    v-bind:class="[{ currentslider: currentSlide(Math.floor(ia)), noncurrentslider: !currentSlide(Math.floor(ia))}]"
                                    v-on:click="goToSlide(Math.floor(ia));"
                                >
                                    <div v-html="langConv(rowa.slide[0].tabname)"></div>
                                </div>
                            </div>
                        </template>

                        <template v-if="rowa.slide[0].slidertype=='W'">
                            <div class="cell small-3" :key="ia">
                                <div
                                    class="basicslider"
                                    v-bind:class="[{ currentslider: currentSlide(Math.floor(ia)), noncurrentslider: !currentSlide(Math.floor(ia))}]"
                                    v-on:click="goToSlide(Math.floor(ia));"
                                >
                                    <div v-html="langConv(rowa.slide[0].tabname)"></div>
                                </div>
                            </div>
                        </template>

                        <template  v-if="rowa.slide[0].slidertype.startsWith('B') && rowa.slide[0].Best != undefined">
                            <div class="cell small-3" :key="ia">
                                <div
                                    class="basicslider"
                                    v-bind:class="[{ currentslider: currentSlide(Math.floor(ia)), noncurrentslider: !currentSlide(Math.floor(ia))}]"
                                    v-on:click="goToSlide(Math.floor(ia));"
                                >
                                    <div v-html="langConv(rowa.slide[0].tabname)"></div>
                                </div>
                            </div>
                        </template>

                        <template  v-if="rowa.slide[0].slidertype=='PP'">
                            <div class="cell small-3" :key="ia">
                                <div
                                    class="basicslider"
                                    v-bind:class="[{ currentslider: currentSlide(Math.floor(ia)), noncurrentslider: !currentSlide(Math.floor(ia))}]"
                                    v-on:click="goToSlide(Math.floor(ia));"
                                >
                                    <div v-html="langConv(rowa.slide[0].tabname)"></div>
                                </div>
                            </div>
                        </template>
                        <template  v-if="rowa.slide[0].slidertype=='AI'">
                            <div class="cell small-3" :key="ia">
                                <div
                                    class="basicslider"
                                    v-bind:class="[{ currentslider: currentSlide(Math.floor(ia)), noncurrentslider: !currentSlide(Math.floor(ia))}]"
                                    v-on:click="goToSlide(Math.floor(ia));"
                                >
                                    <div v-html="langConv(rowa.slide[0].tabname)"></div>
                                </div>
                            </div>
                        </template>

                    </template>
</div>
            </template>
            </div>
       
</div>


        </template>
    </div>
</template>

<script>

// import { Store } from 'vuex/dist/vuex.common.js';
import singleadverts from '/src/components/adverts/singleadverts.vue'
import kit from '/src/components/image/kit.vue';

export default {
    name: "adcarousel",
    components: {
        singleadverts,
        kit
    },
    data() {
        return {
            images: [],
            slides: null,
            slidesdata: null,
            slidesloaded: false,
            featurecounter: 0,
            intervalID: undefined,
            page: 0
        }
    },
     async serverPrefetch() {

         try {

                let data = this.$store.state.ads;

                 //filter out x and y types (or any types that are not catered for in the body of the code)
                    for (let i = data.length - 1; i >= 0; i--) {
                        const item = data[i].slide[0].slidertype;
                        // Your condition for removal
                        if (!['O','I','P','W','BP','BX','BF','PP','AI'].includes(item)) {
                            data.splice(i, 1);   // removes the element at index i
                        }
                    }

                    this.slidesdata = data
                    this.slidesLoaded()

                } catch(error) {
                   console.log(error)
               } finally {
                    this.isloading  = false;
                    this.isvisible = "block";
               }

        },
    computed: {
        currentIndex: {
            cache: false,
            get() {
                return this.page
                //return this.$refs.carousel ? this.$refs.carousel.currentPage : 0;
            }
        }
    },

    mounted() {
        // this.pageChange(0);
    },
    created() {
        if(!this.$store.state.wasSSR) {
        try {
            this.getSlideData();
        } catch (e) {
            console.log(e);
        }
    }
    },
    methods: {
        clickGoComps: function (navigate,compdesc,compid) {
            let eventParams = compdesc + '-' + compid + '-0-1';
            this.$store.commit('setEventParams',eventParams);
            this.$nextTick(() => {
                navigate();
            });
        },

        clickGoEvents: function (navigate,bettype,bid) {
            this.$store.commit('setBid',bid);
            this.$store.commit('setBetType',bettype);
            navigate();
        },

        previousMonth() {
            const currentDate = new Date();
            var prevmonth = this.$displayDate(
                new Date(currentDate.getFullYear(), currentDate.getMonth() - 1),
                this.$dateformattype.monthyearnotime
            );
            return prevmonth;
        },

        HTMLClicked: function (val) {
            //before moving off cancel timer
            clearInterval(this.intervalID)
            this.intervalID = undefined;
            this.$router.push(this.url[this.featurecounter-1])
        },

        pageChange: function (page) {

            //turn interval on and off if not page 0
            if (page != 0) {
                //run updateScreen Manually for the first time
                clearInterval(this.intervalID)
                this.intervalID = undefined;
            } else {
                this.intervalID = setInterval(this.updateScreen,4000);
            }
        },

        getArrayValue: function (arr,value){
            return arr[0][value]
        },
        imageURL: function (val1, val2) {
            return val1 + val2
        },

        goToSlide: function (slideNo) {
            this.$refs.carousel.goto(slideNo);
        },

        currentSlide: function (slideNo) {
            var bn = false;
            if (slideNo == this.currentIndex) {
                bn = true;
            }
            return bn;
        },

        getStaticSlide: function (filename) {
            return require("/public/assets/slides/" + filename);
        },

        //get data for banners
        getSlideData: function () {
            try {
                //does the country have a language version of the slider 21/12/2023 - Test for Germany only
                var country =  this.$store.state.countryname;
                country = this.backtoEnglish(country);


                let path = process.env.VUE_APP_DATA + "slider " + country + ".json"

                this.localJSONLoad(path).then(response => {

                    //filter out x and y types (or any types that are not catered for in the body of the code)
                    for (let i = response.length - 1; i >= 0; i--) {
                        const item = response[i].slide[0].slidertype;
                        // Your condition for removal
                        if (!['O','I','P','W','BP','BX','BF','PP','AI'].includes(item)) {
                            response.splice(i, 1);   // removes the element at index i
                        }
                    }

                    this.slidesdata = response
                    this.slidesLoaded()
                }).catch(error => {
                    console.log(error)
                });

            } catch (e) {
                console.log(e)
            }
        },

        slidesLoaded: function () {
            this.slidesloaded = true;
            this.$emit("slides-loaded");
        }
    }
}
</script>

<style scoped>
@import "../../style/bkmsmall.css";

#bg {
    width: 100% !important;
    height: 100% !important;
    background-size: cover !important;
}

.slidertext {
    background-color: #F2F2F2;
    color: #1E1E1E;
    font-size: 12px;
    font-weight: 500;
    border-radius: 50%;
}

.slidertextsimple {
    background-color: #F7FCFB ;
    /* border-top: 1px #444444 solid;
    border-bottom: 1px #444444 solid; */

    color: #1E1E1E;
    padding:3px;
    font-size: 13px;
    font-weight: 500;

}

.slidertextsmall {
    background-color: #F7FCFB ;
    /* border-top: 1px #444444 solid;
    border-bottom: 1px #444444 solid; */
    color:white;
   
    padding:2px;
    font-size: 9px;
    font-weight: 400;
}


.slidertextleft {
    background-color: #F2F2F2;
    /* border-left: 1px #444444 solid;
    border-top: 1px #444444 solid;
    border-bottom: 1px #444444 solid; */
    color: 1E1E1E;
    padding:3px;
    font-size: 12px;
    font-weight:500;
    border-radius: 14px 0px 0px 14px;
}

::v-deep(.slidertextodds) {
    color: black;
    background-color: #FFFF8F;
    /* border: gold solid 1px; */
    padding:3px;
    font-size: 12px;
    font-weight:500;

}

.slidertextright {
    background-color: #F2F2F2;
    /* border-right: 1px solid #444444;
    border-top: 1px solid #444444;
    border-bottom: 1px solid #444444; */

    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;                 /* horizontal padding */
    font-size: 12px;
    font-weight: 500;
    color: #1E1E1E;

    border-radius: 0 14px 14px 0;    /* 🔥 ONLY right-hand curves */
    white-space: nowrap;
    flex: 0 0 auto;
}

.arrow {
    display: inline-block;              /* removes baseline influence */
    font-size: 14px;
    line-height: 1;
}

/* make the pill segments behave nicely in flex */
.slidertextleft,
.slidertextsimple,
.slidertextodds,
.slidertextright
.slidertextsmall {
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    flex: 0 0 auto; /* don't grow or shrink */
}

/* stop wrapping inside the pill row */
.slider-row {
    flex-wrap: nowrap;
}



.basicslider {
    font-size: 13px;
    background-color:white;
    color: black;
    font-weight: 400;
    padding: 6px;
}

.currentslider {
    border-bottom: 3px solid gold;
    /* border-radius: 0px 0px 5px 5px; */
    border-right: #dEdEdE solid 1px;
    cursor: pointer;
    font-weight: 600;
}

.noncurrentslider {
    font-weight: 500;
    border-bottom: 1px solid #dEdEdE ;
    /* border-radius: 0px 0px 5px 5px; */
    border-right: #dEdEdE  solid 1px;
    cursor: pointer;
}

/* .VueCarousel-navigation-button {
    font-size: x-small !important;
} */

.pill-row-wrapper {
  padding: 2px 0;
}

.pill-row-wrapper-odds {
  padding: 0 0;
}

.no-gutters {
  margin-left: 0;
  margin-right: 0;
}

.no-gutters > .cell {
  padding-left: 0;
  padding-right: 0;
}

.pillwrap {
  background: #F2F2F2;
  border-radius: 14px;
  overflow: hidden;   /* 🔥 kills all micro gaps */
}

.pillwrap .slidertextleft,
.pillwrap .slidertextsimple {
  background: transparent;
}

.slider-row {
  align-items: stretch;
  line-height: 1.5;
}



.slideheader {
    position: absolute;
    top: 13px;          /* SAME as your previous margin-top value */
    left: 0;            /* <-- forces it to the left edge */

    display: inline-flex;
    align-items: center;
    gap: 8px;
    /* white-space: nowrap; */
border-left: 3px solid #FFD400;
    background-color: #0B0F2B;
    padding: 6px 14px;
    font-weight: 500;
    font-size: 0.9em;
    color: white;
    z-index: 999;
 border-radius: 0 6px 6px 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* .slideheader2 {position:absolute; margin-top: 20px; background-color:#D12F6A;border-radius:0px 20px 20px 0px; padding:4px 10px 4px 15px;font-weight:500; font-size:1.2em;z-index:99;color:#0D0638;} */

.container {
    position: relative;             /* so .slideheader is anchored here */
    display: flex;
    align-items: center;            /* center vertically */
  /*  justify-content: center; /*       /* center horizontally */
    height: 238px;                  /* Full height of the viewport */
}

/* Responsive square using viewport units */
.square {
     width: 35%;
    height: 238px;
    /* background-color: #0B0F2B; */
    z-index: 3; 
}

.top-tab{
    background-color: #274C77;
    padding-top: 2px;
    padding-bottom: 2px;
    border-radius: 10px 10px 0px 0px;
    color: white
}

.triangle {
    width: 10%;
    height: 0;
    /* padding-top: 238px;
    background-color: #0B0F2B; */
    clip-path: polygon(0 100%, 0 0, 100% 100%);
    margin-left:-1px;
    z-index: 2;
}

.container.hero-bg {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;


    background-color: rgba(11, 15, 43, 0.45);
    background-blend-mode: multiply;

    height: 238px;
}

.auto-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    width: 0;
    flex: 1 1 0;
}

/* Override default dot styles */
::v-deep(.ssr-carousel-dots) {
  margin-top:5px !important;
  margin-bottom:5px !important;
}

</style>


